export default () => {
    let cookieDaysLifeTime = 30;
    let cookiePopup = document.querySelector(".cookie-popup");   
   
    function getCookie(name) {
        let value = "; " + document.cookie;
        let parts = value.split("; " + name + "=");
        if (parts.length == 2) return parts.pop().split(";").shift();
    }

    function setCookie(name, value, days) {
        var d = new Date();
        d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
        document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
    }

    if (cookiePopup) {
        const cookieClose = cookiePopup.querySelector('.close-cookie')
        let cookieVal = getCookie("cookiesPolicy");
        let acceptBtn = cookiePopup.querySelector(".apply-cookie");
        if (cookieVal !== "accepted") {
            cookiePopup.classList.add("cookie-popup--visible");
        }
        if (acceptBtn) {
            acceptBtn.addEventListener("click", function () {
                setCookie("cookiesPolicy", "accepted", cookieDaysLifeTime);
                cookiePopup.classList.toggle("cookie-popup--visible");
            });
        }
        cookieClose.addEventListener("click", function () {
            cookiePopup.classList.remove("cookie-popup--visible");
        });
    }

   
  
};